import styled from 'styled-components';

export const WhatsappForm = styled.a`
    display: flex;
    padding: 10px 10px;
    text-decoration: none;
`

export const WhatsappButton = styled.button`
  min-width: 240px;
  width: auto;
  height: 54px;
  
  color: var(--white);
  background-color: var(--whatsapp-color);
  
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  gap: 10px;
  font-weight: 600;
  letter-spacing: 0.2px;

  border: none;
  border-radius: 30px;

  font-size: 16px;

  img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    cursor: pointer;
    background-color: #179e4d;
    transform: scale(1.03);
    transition: 0.15s ease-in-out;
  }
`;